var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 115,
    viewBox: "0 0 136 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0489 41.7866C15.7972 45.24 8.17141 46.9637 6.35485 52.7979C4.54449 58.6259 9.73997 64.7082 20.1371 76.8665L22.8279 80.0099C25.779 83.4633 27.2608 85.1931 27.9241 87.3259C28.5875 89.4649 28.3643 91.7713 27.9179 96.378L27.5087 100.575C25.9402 116.801 25.1528 124.911 29.9019 128.513C34.651 132.115 41.7932 128.829 56.0653 122.257L59.7666 120.558C63.8213 118.686 65.8486 117.756 68 117.756C70.1513 117.756 72.1787 118.686 76.2396 120.558L79.9285 122.257C94.2068 128.829 101.349 132.115 106.092 128.519C110.847 124.911 110.06 116.801 108.491 100.575M115.863 76.8665C126.26 64.7144 131.456 58.6321 129.645 52.7979C127.835 46.9637 120.203 45.2338 104.951 41.7866L101.008 40.8938C96.6743 39.9142 94.5106 39.4244 92.7684 38.1038C91.0263 36.7832 89.9165 34.7806 87.6845 30.7754L85.651 27.1297C77.7958 13.0432 73.8713 6 68 6C62.1287 6 58.2042 13.0432 50.349 27.1297",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon3);
export default __webpack_public_path__ + "static/media/about-icon3.f4a723b0c019e27b7390315e23516ba4.svg";
export { ForwardRef as ReactComponent };